import { Component } from '@angular/core';

@Component({
    selector: 'app-agrimaker',
    templateUrl: './agrimaker.component.html',
    styleUrls: ['./agrimaker.component.scss'],
    standalone: false
})
export class AgrimakerComponent {}
